import React from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './featureSlider.module.css';


function FeatureSlide(props) {
    return (
        <div className={styles.listingItem}>
            <a href="#" className={styles.itemImage}>
                {
                    (props.item.image) ? <img src={props.item.image.image.asset.url} alt="" /> : ``
                }
            </a>
            <a href="#" className={styles.itemDetails}>
                <h4>{props.item.title}</h4>
                <PortableText blocks={props.item.desc} />
            </a>
        </div>
    );
}
  
export default FeatureSlide;